import * as Cookies from 'js-cookie';

const IE11 = window.navigator.userAgent.indexOf('Trident/7.0') > -1;

let previousFavorites = getFavorites();
let currentFavorites = getFavorites();

let cookiesEnabled = null;

// check if cookies are enabled by trying to store one and then retrieve it
// see below for the rationale of why we have to do that. we can't just use
// navigator.cookieEnabled because that returns `true` even if we're not on
// https and our cookies won't be stored correctly.
function checkCookieSupport() {
    if (cookiesEnabled != null) {
        return cookiesEnabled;
    }

    let domain = window.location.hostname;

    domain = domain.replace(/^www\./, '');
    domain = domain.replace(/^cms\./, '');
    domain = domain.replace(/^es\./, '');

    Cookies.set('cookies-enabled', 'true', {
        expires: new Date().getTime() + 1000,
        domain: domain,
        path: '/',
        secure: true,
    });

    if(Cookies.get('cookies-enabled')) {
        cookiesEnabled = true;
    } else {
        cookiesEnabled = false;
    }

    return cookiesEnabled;
}

/*
    returns an array of (performanceID, timestamp)
    if the cookie is not already set or is malformed, will set it to empty array
*/
function getFavorites() {
    let favorites = [];

    try {
        favorites = JSON.parse(Cookies.get('favorites'));
    } catch {
        // console.warn('malformed favorites string, resetting');

        clear();

        favorites = [];
    }

    return favorites;
}

/*
    sets the favorites cookie to the provided value, with a 1 year expiration
    (helper function)
*/
function setFavoritesCookie(value) {
    // if this check isn't here, we get into an infinite loop and crash the tab 😳
    // this happens because we fire off a `notify()` call, which makes all favorites
    // elements call `getFavorites()`, which in turn realises that our favorites
    // cookie is empty, and calls `clear()` to reset it... which then calls this
    // function again. good times.
    if(!checkCookieSupport()) {
        // console.warn('you have cookies disabled, or you\'re not browsing through a secure connection so saving cookies won\'t work');
        return;
    }

    previousFavorites = currentFavorites;
    currentFavorites = value;

    let d = new Date();
    let year = d.getFullYear();
    let month = d.getMonth();
    let day = d.getDate();
    let yearInFuture = new Date(year + 1, month, day);

    let domain = window.location.hostname;

    domain = domain.replace(/^www\./, '');
    domain = domain.replace(/^cms\./, '');
    domain = domain.replace(/^es\./, '');

    Cookies.set('favorites', JSON.stringify(value), {
        expires: yearInFuture,
        domain: domain,
        secure: true,
    });
}

/*
    sets the favorites cookie to the provided value
*/
function setFavorites(favorites) {
    setFavoritesCookie(favorites);

    notify();
}

/*
    adds a performance to favorites
    performanceID: the id of the performance
    timestamp: the unix timestamp of the performance (*seconds* since 1/1/1970)
*/
function favorite(performanceID, timestamp) {
    let favs = getFavorites();
    // remove current performance ID from cookie if we already
    // have it favorited. this is basically unfavorite()
    // but calling that would needlessly update the cookie
    favs = favs.filter(x => x.performanceID != performanceID);

    favs.push({
        performanceID: performanceID,
        timestamp: timestamp,
    });

    setFavorites(favs);
}

/*
    adds multiple favorites in a batch
    arr: array of objects with {
        id: performance ID
        timestamp: unix timestamp of performance (*seconds* since 1/1/1970)
    }
*/
function favoriteMultiple(arr) {
    let favs = getFavorites();
    for(let performance of arr) {
        // remove current performance ID from cookie if we already
        // have it favorited. this is basically unfavorite()
        // but calling that would needlessly update the cookie
        favs = favs.filter(x => x.performanceID != performance.id);

        favs.push({
            performanceID: performance.id,
            timestamp: performance.timestamp,
        });
    }

    setFavorites(favs);
}

/*
    removes a performance with a given performanceID
*/
function unfavorite(performanceID) {
    let favs = getFavorites();
    favs = favs.filter(x => x.performanceID != performanceID);

    setFavorites(favs);
}

/*
    returns whether a performance is in the favorites array
*/
function isInFavorites(performanceID) {
    let favs = getFavorites();
    return favs.find(x => x.performanceID == performanceID) ? true : false;
}

function clear() {
    setFavorites([]);
}

function notify() {
    if (!IE11 && checkCookieSupport()) {
        let event = new CustomEvent('favoritesChanged', {
            detail: {
                previous: previousFavorites,
                current: currentFavorites,
            }
        });
        window.dispatchEvent(event);
    }
}

function getBlocksofficeURL() {
    let boDomain = (<any>window).DJANGO.boDomain;
    // let packageID = 739;
    let localDataTableId = (<any>window).DJANGO.favouritesToolbarMappingID;
    let href = `${boDomain}/booking/cyo-favourites/package/${localDataTableId}`;

    return href;
}

export default {
    getFavorites,
    setFavorites,
    setFavoritesCookie,
    favorite,
    unfavorite,
    isInFavorites,
    favoriteMultiple,
    clear,
    getBlocksofficeURL,
}



// WEBPACK FOOTER //
// ./@modules/favorites/favorites.ts